$(document).ready(function() {  
    $('.left-slide-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
      infinite:false,
    fade: true,
    asNavFor: '.right-slide-nav'
  });
  $('.right-slide-nav').slick({
    slidesToShow:1,
    slidesToScroll: 1,
    asNavFor: '.left-slide-for',
    dots: false,
    infinite:false,
    centerMode: false,
    focusOnSelect: true,
    arrows: false
  });

jQuery('body').on('click','.Size .variant_block', function(){
if (!$('fieldset').hasClass("Color")) {
   setTimeout(function () {
      jQuery('.thumbnail-list__item').show();
   }, 1);
}
});

  // color swatches js start 
  // $(document).ready(function () {
  //         $('.color-swtach label').click(function () {
  //             $(this).parent().find('.color-label').removeClass('active');
  //             $(this).addClass('active');
  //             var link = $(this).parents('.card__content').find('.custom-link').attr('href');
  //             var newlink = link.split('?variant=')[0];
  //             var id = $(this).attr('data-vid');
  //             var img = $(this).attr('data-image');
  //             console.log(newlink);
  //             console.log(id);
  //             $(this).parents('.card__content').find('.custom-link').attr('href', newlink + "?variant=" + id);
  //             var colorname = $(this).attr('data-vall');
  //             $(this).parents('.card-information').find('.current-color').text(colorname);
  //             $(this).parents('.card-wrapper').find('.product-variant-image').attr('srcset', img);
  //         });
  //         $('body').on('click', '.color-label', function () {
  //             var color = $(this).attr('data-vall');
  //             $('.color-name').html(color);
  //         });
  // });

// $('.size_collection label').click(function(){
//    $(this).parent().find('.size-label').removeClass('active');
//     $(this).addClass('active');
//          });
// color swatches js end

// product variant name inside the option name start

// var def_select_var = $('.Size .variant_block input.unavailable:checked').val();
//   jQuery('.Size .select_variant_name').text(def_select_var);

var def_select_var = $('.Color .variant_block input.unavailable:checked').val();
  jQuery('.Color .select_variant_name').text(def_select_var);
  
// jQuery('body').on('click','.Size .variant_block', function(){
//   var select_var = $(this).find('input.unavailable').val();    
//   jQuery(this).parents('.Size').find('.select_variant_name').text(select_var);
// });
jQuery('body').on('click','.Color .variant_block', function(){
  var select_var = $(this).find('input.unavailable').val();    
  jQuery(this).parents('.Color').find('.select_variant_name').text(select_var);
});

  
        $(document).ready(function() {
  $(".keen-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite:true,
    dots: false,
    pauseOnHover: false,
    mousewheelControl: true,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          arrows: true,
          slidesToShow: 1,
          infinite:true
        }
      },
        {
        breakpoint: 749,
        settings: {
          arrows: true,
          slidesToShow: 1,
          infinite:true
        }
      }
    ]
  });
 });
  // product thumbnail js start 

 //      $(document).ready(function() {
 //  $(".product-thumb").slick({
 //    slidesToShow: 3,
 //    slidesToScroll: 1,
 //    arrows: true,
 //    infinite:true,
 //    dots: false,
 //    vertical: true,
 //    draggable: false,
 //    verticalSwiping: true,
 //    pauseOnHover: false,
 //    mousewheelControl: true,
 //    responsive: [
 //      {
 //        breakpoint: 989,
 //        settings: {
 //          arrows: true,
 //          slidesToShow: 3,
 //          infinite:true
 //        }
 //      },
 //        {
 //        breakpoint: 749,
 //        settings: {
 //          arrows: true,
 //          slidesToShow: 4,
 //          infinite:true
 //        }
 //      }
 //    ]
 //  });
 // });

// debounce from underscore.js
// function debounce(func, wait, immediate) {
// 	var timeout;
// 	return function() {
// 		var context = this, args = arguments;
// 		var later = function() {
// 			timeout = null;
// 			if (!immediate) func.apply(context, args);
// 		};
// 		var callNow = immediate && !timeout;
// 		clearTimeout(timeout);
// 		timeout = setTimeout(later, wait);
// 		if (callNow) func.apply(context, args);
// 	};
// };

// use x and y mousewheel event data to navigate flickity
function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
  // do not trigger a slide change if another is being animated
  if (!slick_is_animating) {
    // pick the larger of the two delta magnitudes (x or y) to determine nav direction
    var direction =
      Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

    console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

    if (direction > 0) {
      // next slide
      slick_instance.slick("slickNext");
    } else {
      // prev slide
      slick_instance.slick("slickPrev");
    }
  }
}

// debounce the wheel event handling since trackpads can have a lot of inertia
var slick_handle_wheel_event_debounced = debounce( 
  slick_handle_wheel_event
  , 300, true
);

// init slider 
const slick_2 = $(".slides");
slick_2.slick({
  dots: false,
  vertical: true,
  slidesToShow: 4,
  // verticalSwiping: true,
   infinite:false,
  swipe: false,
  arrows: true
});
var slick_2_is_animating = false;

slick_2.on("afterChange", function(index) {
  console.log("Slide after change " + index);
  slick_2_is_animating = false;
});

slick_2.on("beforeChange", function(index) {
  console.log("Slide before change " + index);
  slick_2_is_animating = true;
});

slick_2.on("wheel", function(e) {
  slick_handle_wheel_event_debounced(e.originalEvent, slick_2, slick_2_is_animating);  
});

  // product thumbnail js end 

// Product tab js start
  });